import React from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import AppBar from '@material-ui/core/AppBar';
import Toolbar from '@material-ui/core/Toolbar';
import Typography from '@material-ui/core/Typography'
import {Menu, MenuItem, Button } from '@material-ui/core';
import AccountCircle from '@material-ui/icons/AccountCircle';
import IconButton from '@material-ui/core/IconButton';
import { Link } from 'react-router-dom';
import AOLogo from '../images/logos/aodocs.svg';
import Avatar from '@material-ui/core/Avatar';

import { connect } from 'react-redux';
import { signOut } from '../actions/gapi';
import Hidden from '@material-ui/core/Hidden';
import { FormattedMessage, injectIntl } from 'react-intl';
import { clearMessages, clearErrors } from '../actions/messages';

/**
 * Default head used in Dashboard layout
 * Display the google user profil, along with a "logout" button
 * Also displays a page title / breadcrumb
 */

const styles = theme => ({
  appBar: {
    zIndex: 1300,
    flex:0,
    backgroundColor:'#FFFFFF',
  },
  title: {
    textAlign: 'left',
    flex: 1,
    color: '#787878',
  },
  titleLink: {
    color: '#787878',
    textDecoration: 'none',
  },
  menuButton: {
    marginLeft: -12,
    marginRight: 20,
  },
  faqButton: {
    marginRight: 16,
    color: 'rgba(0, 0, 0, 0.56)',
  },
  logo: {
    height: 24,
    marginRight: 20,
    width: 'auto',
    verticalAlign: 'middle',
  },
  email: {
    color:'#787878',
    marginRight: 12,
  },
  iconButton: {
    padding: 0,
  }
});

class Header extends React.Component {

  state = {
    anchorEl: null
  };

  handleMenu = event => {
    this.setState({ anchorEl: event.currentTarget });
  };

  handleClose = () => {
    this.setState({ anchorEl: null });
  };

  render() {
    const { classes, handleLogout, handleBreadcrumb, intl } = this.props;
    const { anchorEl } = this.state;
    const open = Boolean(anchorEl);

    const SITE_TITLE = intl.messages['site.title'];

    const {
      user,
      title
    } = this.props;

    document.title = title ? `${title} › ${SITE_TITLE}` : SITE_TITLE;

    const menu = [{
      title: <span>
        <img src={AOLogo} alt={SITE_TITLE} className={classes.logo} />
        {SITE_TITLE}
      </span>,
      link: '/'
    }]

    if (title) {
      menu.push({
        separator: true
      });
      menu.push({
        title: title
      })
    }

    return (
      <div>
        <AppBar position="fixed" className={classes.appBar} >
          <Toolbar>
            <Typography variant="h6" color="inherit" className={classes.title}>
              {menu.map((item, i) => (
                item.separator
                  ? <span key={i} className={classes.separator}> › </span>
                  : item.link
                    ? <Link 

                        key={i} 
                        to={item.link} 
                        className={classes.titleLink}
                        onClick={handleBreadcrumb}
                      >
                        {item.title}
                      </Link>
                    : <span key={i}>{title}</span>
              ))}
            </Typography>
            <div>
              <Button
                  className={classes.faqButton}
                  size="large"
                  href="https://sites.google.com/altirnao.com/aolm-faq/my-account-faq"
                  target="_blank">
                  <FormattedMessage  id='header.faq.button' />
              </Button>
              <Hidden smDown>
                <span className={classes.email}>{user && user.email}</span>
              </Hidden>
              <IconButton
                className={classes.iconButton}
                aria-owns={open ? 'menu-appbar' : null}
                aria-haspopup="true"
                onClick={this.handleMenu}
                color="inherit"
              >
                {user && user.imageUrl
                  ? <Avatar src={user.imageUrl} />
                  : <AccountCircle />
                }

              </IconButton>
              <Menu
                id="menu-appbar"
                anchorEl={anchorEl}
                anchorOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                transformOrigin={{
                  vertical: 'top',
                  horizontal: 'right',
                }}
                open={open}
                onClose={this.handleClose}
              >
                {user && user.email && <MenuItem disabled>{user.email}</MenuItem>}
                <MenuItem onClick={handleLogout}>
                  <FormattedMessage id='header.logout.button' />
                </MenuItem>
              </Menu>
            </div>
          </Toolbar>
        </AppBar>
      </div>
    );
  }
}

Header.propTypes = {
  classes: PropTypes.object.isRequired,
  handleLogout: PropTypes.func.isRequired,
};

const mapStateToProps = state => {
  return {
    user: state.googleUser
  };
}

const mapDispatchToProps = dispatch => {
  return {
    handleLogout: () => dispatch(signOut()),
    handleBreadcrumb: () => {
      dispatch( clearMessages() );
      dispatch( clearErrors() );
    },
  };
}

const HeaderContainer = connect(
  mapStateToProps,
  mapDispatchToProps
)(
  withStyles(styles)(
    injectIntl(Header)
  )
);

export default HeaderContainer;


// WEBPACK FOOTER //
// ./src/components/Header.js